import styled from "styled-components";

export const Container = styled.li`
  border-bottom: 1px solid #eee;
`